import React, { useState } from 'react'

import { Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import checkIcon from '../assets/check.png'
import listy from '../assets/listy.svg'
import malykvet from '../assets/malykvet.svg'
import vazka from '../assets/vazka.svg'
import velkykvet from '../assets/velkykvet.svg'
import { Package, PaymentPeriod } from '../types/gopay'


export const PriceTable = ({
                               onPackageSelect,
                               hideFreePackage = false,
                               hideTitle = false,
                               defaultPeriod,
                               defaultPackage
                           }:
                               {
                                   onPackageSelect?: (pckg: Package, period: PaymentPeriod) => void,
                                   hideFreePackage?: boolean,
                                   hideTitle?: boolean,
                                   defaultPeriod?: PaymentPeriod,
                                   defaultPackage?: Package
                               }
) => {
    const [paymentPeriod, setPaymentPeriod] = useState<PaymentPeriod>(defaultPeriod ?? PaymentPeriod.MONTHLY)
    const [isCheckedFree, setIsCheckedFree] = useState(false)
    const [isCheckedBasic, setIsCheckedBasic] = useState(false)
    const [isCheckedMedium, setIsCheckedMedium] = useState(false)
    const [isCheckedPremium, setIsCheckedPremium] = useState(false)
    const {t} = useTranslation()
    return (
        <>
            <Container>
                {!hideTitle ? <Row>
                    <h3 className="font-vollkorn fs-40 primary-text-color mt-5 mb-5">{t('price_choose')}</h3>
                </Row> : null}
                <div className="d-flex justify-content-center gap-3">
                    <button
                        onClick={() => setPaymentPeriod(PaymentPeriod.YEARLY)}
                        className={`btn btn-payment-period btn-primary  btn-amani w-auto d-inline-block text-uppercase ${paymentPeriod === PaymentPeriod.YEARLY ? 'active' : ''}`}>{t('price_yearly')}
                    </button>
                    <button
                        onClick={() => setPaymentPeriod(PaymentPeriod.MONTHLY)}
                        className={`btn btn-payment-period btn-primary btn-amani w-auto d-inline-block text-uppercase ${paymentPeriod === PaymentPeriod.MONTHLY ? 'active' : ''}`}>{t('price_monthly')}
                    </button>
                </div>

                <Row>
                    <StyledWrapper>
                        <div className="content">

                            <div className="free box">
                                <h2 className="title">Free</h2>
                                <div className="view">
                                    <div className="icon">
                                        <img src={vazka} alt="vazka"/>
                                    </div>
                                    <div className="cost">
                                        <p className="amount">&euro;{paymentPeriod === PaymentPeriod.MONTHLY ? '0' : '0'}</p>
                                        <p className="detail">{paymentPeriod === PaymentPeriod.MONTHLY ? t('price_monthly') : t('price_yearly')} {t('price_with_vat')}
                                            ({paymentPeriod === PaymentPeriod.MONTHLY ? '0' : '0'}&euro; {t('price_per_day')})</p>
                                    </div>
                                </div>
                                <p className="desc-text" dangerouslySetInnerHTML={{__html: t('price_free_desc')}}/>
                                <div className="description">
                                    <ul>
                                        <li>{t('price_free_notes')}</li>
                                        <li>{t('price_free_calendar')}</li>
                                        <li>{t('price_free_time')}</li>
                                        <li dangerouslySetInnerHTML={{__html: t('price_free_social')}}/>
                                    </ul>
                                </div>

                                <div className={'checkbox-wrapper'}>
                                    {t('price_sub_auto_renew')}
                                    <br/>
                                    <br/>
                                    {t('price_sub_cancel')}
                                    <br/>
                                    <br/>

                                    <div className="form-group form-check">
                                        <input type="checkbox" className="form-check-input"
                                               name="acceptTerms" id="acceptTerms" checked={isCheckedFree}
                                               onChange={() => setIsCheckedFree(!isCheckedFree)}/>


                                        <label className="form-check-label" htmlFor={'acceptTerms'}>
                                            {t('price_agree_terms')}&nbsp;
                                            <a
                                                href={'/dokumenty/vseobecne-podmienky2.pdf'}
                                                target="_blank" rel="noreferrer">{t('price_sub_terms')}</a>
                                        </label>
                                    </div>
                                </div>
                                <div className="button">
                                    {onPackageSelect ? <button disabled={defaultPackage === Package.FREE}
                                                               className={`text-uppercase ${defaultPackage === Package.FREE ? 'active' : ''}`}
                                                               onClick={() => onPackageSelect(Package.FREE, paymentPeriod)}>{defaultPackage === Package.FREE ? t('price_active') : t('price_order')}</button> :
                                        <Link to={`/register?package=${Package.FREE}&period=${paymentPeriod}`}>
                                            <button disabled={!isCheckedFree} className="text-uppercase">{t('price_order')}
                                            </button>
                                        </Link>}
                                </div>
                            </div>

                            <div className="basic box">
                                <h2 className="title">Basic</h2>
                                <div className="view">
                                    <div className="icon">
                                        <img src={listy} alt="listy"/>
                                    </div>
                                    <div className="cost">
                                        <p className="amount">&euro;{paymentPeriod === PaymentPeriod.MONTHLY ? '21,99' : '241,99'}</p>
                                        <p className="detail">{paymentPeriod === PaymentPeriod.MONTHLY ? t('price_monthly') : t('price_yearly')} {t('price_with_vat')}
                                            ({paymentPeriod === PaymentPeriod.MONTHLY ? '0,74' : '0,67'}&euro; {t('price_per_day')})</p>
                                    </div>
                                </div>
                                <p className="desc-text" dangerouslySetInnerHTML={{__html: t('price_basic_desc')}}/>
                                <div className="description">
                                    <ul>
                                        <li dangerouslySetInnerHTML={{__html: t('price_basic_clients')}}/>
                                        <li>{t('price_notes')}</li>
                                        <li>{t('price_calendar')}</li>
                                        <li>{t('price_time_tracking')}</li>
                                        <li>{t('price_invoicing')}</li>
                                        <li>{t('price_social')}</li>
                                    </ul>
                                </div>

                                <div className={'checkbox-wrapper'}>
                                    {t('price_sub_auto_renew')}
                                    <br/>
                                    <br/>
                                    {t('price_sub_cancel')}
                                    <br/>
                                    <br/>

                                    <div className="form-group form-check">
                                        <input type="checkbox" className="form-check-input"
                                               name="acceptTerms" id="acceptTerms" checked={isCheckedBasic}
                                               onChange={() => setIsCheckedBasic(!isCheckedBasic)}/>


                                        <label className="form-check-label" htmlFor={'acceptTerms'}>
                                            {t('price_agree_terms')}&nbsp;
                                            <a
                                                href={'/dokumenty/vseobecne-podmienky2.pdf'}
                                                target="_blank" rel="noreferrer">{t('price_sub_terms')}</a>
                                        </label>
                                    </div>
                                </div>
                                <div className="button">
                                    {onPackageSelect ? <button disabled={defaultPackage === Package.BASIC}
                                                               className={`text-uppercase ${defaultPackage === Package.BASIC ? 'active' : ''}`}
                                                               onClick={() => onPackageSelect(Package.BASIC, paymentPeriod)}>{defaultPackage === Package.BASIC ? t('price_active') : t('price_order')}</button> :
                                        <Link to={`/register?package=${Package.BASIC}&period=${paymentPeriod}`}>
                                            <button disabled={!isCheckedBasic} className="text-uppercase">{t('price_order')}
                                            </button>
                                        </Link>}
                                </div>
                            </div>

                            <div className="standard box">
                                <h2 className="title">Medium</h2>
                                <div className="view">
                                    <div className="icon">
                                        <img src={malykvet} alt="maly kvet"/>
                                    </div>
                                    <div className="cost">
                                        <p className="amount">&euro;{paymentPeriod === PaymentPeriod.MONTHLY ? '24,99' : '264,99'}</p>
                                        <p className="detail">{paymentPeriod === PaymentPeriod.MONTHLY ? t('price_monthly') : t('price_yearly')} {t('price_with_vat')}
                                            ({paymentPeriod === PaymentPeriod.MONTHLY ? '0,84' : '0,75'}&euro; {t('price_per_day')})</p>
                                    </div>
                                </div>
                                <p className="desc-text" dangerouslySetInnerHTML={{__html: t('price_medium_desc')}}/>
                                <div className="description">
                                    <ul>
                                        <li dangerouslySetInnerHTML={{__html: t('price_medium_clients')}}/>
                                        <li>{t('price_notes')}</li>
                                        <li>{t('price_calendar')}</li>
                                        <li>{t('price_time_tracking')}</li>
                                        <li>{t('price_invoicing')}</li>
                                        <li>{t('price_social')}</li>
                                        <li><strong>{t('price_emailing')}</strong></li>
                                    </ul>
                                </div>
                                <div className={'checkbox-wrapper'}>
                                    {t('price_sub_auto_renew')}
                                    <br/>
                                    <br/>
                                    {t('price_sub_cancel')}
                                    <br/>
                                    <br/>

                                    <div className="form-group form-check">
                                        <input type="checkbox" className="form-check-input"
                                               name="acceptTerms" id="acceptTerms" checked={isCheckedMedium}
                                               onChange={() => setIsCheckedMedium(!isCheckedMedium)}/>


                                        <label className="form-check-label" htmlFor={'acceptTerms'}>
                                            {t('price_agree_terms')}&nbsp;
                                            <a
                                                href={'/dokumenty/vseobecne-podmienky2.pdf'}
                                                target="_blank" rel="noreferrer">{t('price_sub_terms')}</a>
                                        </label>
                                    </div>
                                </div>
                                <div className="button">
                                    {onPackageSelect ? <button
                                            className={`text-uppercase ${defaultPackage === Package.MEDIUM ? 'active' : ''}`}
                                            disabled={defaultPackage === Package.MEDIUM}
                                            onClick={() => onPackageSelect(Package.MEDIUM, paymentPeriod)}>{defaultPackage === Package.MEDIUM ? t('price_active') : t('price_order')}</button> :
                                        <Link to={`/register?package=${Package.MEDIUM}&period=${paymentPeriod}`}>
                                            <button disabled={!isCheckedMedium} className="text-uppercase">{t('price_order')}
                                            </button>
                                        </Link>}
                                </div>
                            </div>

                            <div className="business box">
                                <h2 className="title">Premium</h2>
                                <div className="view">
                                    <div className="icon">
                                        <img src={velkykvet} alt="velky kvet"/>
                                    </div>
                                    <div className="cost">
                                        <p className="amount">&euro;{paymentPeriod === PaymentPeriod.MONTHLY ? '29,99' : '285,99'}</p>
                                        <p className="detail">{paymentPeriod === PaymentPeriod.MONTHLY ? t('price_monthly') : t('price_yearly')} {t('price_with_vat')}
                                            ({paymentPeriod === PaymentPeriod.MONTHLY ? '0,99' : '0,78'}&euro; {t('price_per_day')})</p>
                                    </div>
                                </div>
                                <p className="desc-text" dangerouslySetInnerHTML={{__html: t('price_premium_desc')}}/>
                                <div className="description">
                                    <ul>
                                        <li dangerouslySetInnerHTML={{__html: t('price_premium_clients')}}/>
                                        <li>{t('price_notes')}</li>
                                        <li>{t('price_calendar')}</li>
                                        <li>{t('price_time_tracking')}</li>
                                        <li>{t('price_invoicing')}</li>
                                        <li>{t('price_social')}</li>
                                        <li>{t('price_emailing')}</li>
                                        <li dangerouslySetInnerHTML={{__html: t('price_premium_storage')}}/>
                                    </ul>
                                </div>
                                <div className={'checkbox-wrapper'}>
                                    {t('price_sub_auto_renew')}
                                    <br/>
                                    <br/>
                                    {t('price_sub_cancel')}
                                    <br/>
                                    <br/>

                                    <div className="form-group form-check">
                                        <input type="checkbox" className="form-check-input"
                                               name="acceptTerms" id="acceptTerms" checked={isCheckedPremium}
                                               onChange={() => setIsCheckedPremium(!isCheckedPremium)}/>


                                        <label className="form-check-label" htmlFor={'acceptTerms'}>
                                            {t('price_agree_terms')}&nbsp;
                                            <a
                                                href={'/dokumenty/vseobecne-podmienky2.pdf'}
                                                target="_blank" rel="noreferrer">{t('price_sub_terms')}</a>
                                        </label>
                                    </div>
                                </div>
                                <div className="button">
                                    {onPackageSelect ? <button disabled={defaultPackage === Package.PREMIUM}
                                                               className={`text-uppercase ${defaultPackage === Package.PREMIUM ? 'active' : ''}`}
                                                               onClick={() => onPackageSelect(Package.PREMIUM, paymentPeriod)}>{defaultPackage === Package.PREMIUM ? t('price_active') : t('price_order')}</button> :
                                        <Link to={`/register?package=${Package.PREMIUM}&period=${paymentPeriod}`}>
                                            <button disabled={!isCheckedPremium} className="text-uppercase">{t('price_order')}
                                            </button>
                                        </Link>}
                                </div>
                            </div>

                        </div>

                        {!hideFreePackage ? <div className={'tip-amani'}>
                            <Link to={`/register?package=${Package.PREMIUM}&period=${paymentPeriod}`}>
                                <button
                                    className="btn btn-primary pink-color btn-amani w-auto d-inline-block text-uppercase">{t('price_try_premium')}
                                </button>
                            </Link>
                        </div> : null}
                    </StyledWrapper>
                </Row>
            </Container>
        </>
    )
}


const StyledWrapper = styled.section`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-bottom: 50px;

    .content {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 30px;

        width: 100%;
        // ZMENA: Zväčšené z 1200px na 1350px, aby sa zmestilo (4x300px + 3x30px gap = 1290px)
        max-width: 1350px;
        margin: 80px auto;
        margin-bottom: 10px;
    }

    .box {
        display: flex;
        flex-direction: column;
        // Box má fixnú šírku 300px
        width: 300px;
        border-radius: 10px;

        // Marginy už nie sú potrebné, rieši to 'gap' vyššie
        background: #fff;
        box-shadow: 0 1rem 2rem rgba(0, 0, 0, 10%);
    }

    // ... zvyšok kódu ostáva rovnaký (title, view, icon, cost, atď.)

    .title {
        width: 100%;
        padding: 10px 0;
        font-size: 1.2em;
        font-weight: lighter;
        text-align: center;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        color: #F5F5F4;
    }

    .free .title {
        background: #9B5B7E;
    }

    .basic .title {
        background: #9B5B7E;
    }

    .standard .title {
        background: #9098B0;
    }

    .business .title {
        background: #393E5E;
    }

    .view {
        display: block;
        width: 100%;
        padding: 30px 0 20px;
        background: #F5F5F4;
    }

    .icon {
        display: flex;
        justify-content: center;
    }

    .icon img {
        width: 100px;
    }

    .cost {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        margin-top: 10px;
    }

    .amount {
        font-size: 2.8em;
        font-weight: bolder;
        margin-bottom: 0;
    }

    .detail {
        margin: auto 0 auto 5px;
        font-size: 0.7em;
        font-weight: bold;
        line-height: 15px;
        color: #7D7C7C;
    }

    .checkbox-wrapper {
        padding: 10px 25px;
        font-size: 11px;
        text-align: center;
        margin-top: auto;

        .form-check {
            text-align: left;
        }

        .form-check .form-check-input {
            margin-left: -2.5em;
        }

        .form-check .form-check-label {
            font-size: 14px;
        }
    }

    .desc-text {
        margin: 20px 20px 0px;
        font-size: 14px;
        color: #383e60;
        text-align: center;
    }

    .description {
        margin: 30px auto;
        font-size: 14px;
        color: #383e60;
    }

    ul {
        list-style: none;
        padding: 0;
    }

    li {
        margin-top: 10px;
    }

    li::before {
        content: "";
        background-image: url(${checkIcon});
        background-position: center;
        background-size: cover;
        opacity: 0.5;
        display: inline-block;
        width: 10px;
        height: 10px;
        margin-right: 10px;
    }

    .button {
        margin: 10px auto 30px;
        padding: 0 10px;
    }

    button {
        height: 40px;
        width: 250px;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 0.5px;
        color: #fff;
        border: none;
        border-radius: 10px;
        background: #393E5E;
    }

    button.active,
    button:hover {
        color: #F5F5F4;
        transition: 0.5s;
        border: none;
        transform: scale(1.03);
        background: #CDA5BD;
    }

    button:disabled {
        background-color: gray;
        color: #ccc;
        cursor: not-allowed;
    }

    @media screen and (max-width: 970px) {
        .content {
            margin: 50px auto;
        }
    }
`
